import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
import UEditor from "@/components/UEditor/index.vue";
import LongContentContainer from "@/components/LongContentContainer/index.vue";
let QuestionItem = class QuestionItem extends Vue {
    constructor() {
        super(...arguments);
        this.customToolBars = ["undo", "redo", "|", "paragraph", "|", "fontsize", "|", "bold", "italic", "underline", "strikethrough", "forecolor", "backcolor"];
        this.checkingOption = [
            {
                value: 1,
                label: '正确'
            },
            {
                value: 0,
                label: '错误'
            }
        ];
        this.zoomUrl = '';
        this.showZoomImg = false;
    }
    get type() {
        return this.question.questionType;
    }
    get typeName() {
        const _map = {
            0: "单选题",
            1: "多选题",
            2: "问答题",
            3: "判断题",
            4: "填空题",
            5: "不定项选择题",
            6: "材料题"
        };
        return _map[this.type] || "全部题型";
    }
    get questionContent() {
        const index = this.question.isMaterialQuestion ? `(${this.index + 1})` : `${this.index + 1}.`;
        return `<span style="float: left">${index}（${this.typeName}，分值${this.question.questionScore}）</span>${this.question.questionContent}`;
    }
    get userAnswer() {
        if (this.type === 0) {
            return this.question.userAnswerOptionStr || '-1';
        }
        else if (this.type === 1 || this.type === 5) {
            return this.question.userAnswerOptionStr ? this.question.userAnswerOptionStr.split(',') : [];
        }
        else if (this.type === 3) {
            return Number(this.question.userAnswerOptionStr) || -1;
        }
        else if (this.type === 4) {
            let userAnswer = [];
            try {
                userAnswer = JSON.parse(this.question.userAnswer);
            }
            catch (error) {
                userAnswer = [];
            }
            return userAnswer;
        }
    }
    get questionAnalysis() {
        return `<span style="float: left">题目解析：</span>${this.question.questionAnalysis === '<p></p>' ? '暂无解析' : this.question.questionAnalysis || '暂无解析'}`;
    }
    get questionStatusImage() {
        if (this.question.answerStatus === 1) {
            return require('@/assets/answer_right.png');
        }
        else {
            if (this.question.userAnswer) {
                return require('@/assets/answer_error.png');
            }
            else {
                return require('@/assets/answer_nothing.png');
            }
        }
    }
    get essayQuestionImages() {
        let imageList = [];
        try {
            imageList = JSON.parse(this.question.mixRecord);
        }
        catch (error) {
            imageList = [];
        }
        return imageList;
    }
    created() {
    }
    handleClickImage(url) {
        this.zoomUrl = `${url}?key=${Date.now()}`;
        this.showZoomImg = true;
    }
};
tslib_1.__decorate([
    Prop({ type: Number, default: 0 })
], QuestionItem.prototype, "index", void 0);
tslib_1.__decorate([
    Prop({ type: Object, required: true })
], QuestionItem.prototype, "question", void 0);
QuestionItem = tslib_1.__decorate([
    Component({
        name: 'QuestionItem',
        filters: {
            formatBlankQuestionAnswer(answer) {
                if (!answer)
                    return '';
                try {
                    return JSON.parse(answer.replace(/；/g, ' 或 ')).join('，');
                }
                catch (error) {
                    return '';
                }
            }
        },
        components: {
            Editor: UEditor,
            LongContentContainer
        }
    })
], QuestionItem);
export default QuestionItem;
